module.exports = __webpack_public_path__ + "img/SE.07e6fddc.jpeg";